import type { SearchData } from '@eti/providers';
import type { BoundsType, SegmentsType, TripSegmentType } from '../../../pages/result/models';

type Location = {
  code: string;
  cityCode: string;
};

type SearchRoutes = NonNullable<SearchData['routes']>;

export const isMatchingLocation = (searchLocationCode: string, location?: Location) =>
  [location?.code, location?.cityCode].includes(searchLocationCode);

const filterTripSegments = (segments: SegmentsType) =>
  segments.filter((segment): segment is TripSegmentType => segment.__typename === 'TripSegment');

export const isDifferentOrigin = (
  searchRoutes: SearchRoutes,
  segments: SegmentsType,
  boundIndex: number,
): boolean => {
  const tripSegments = filterTripSegments(segments);

  if (!searchRoutes) {
    return false;
  }

  const searchRoute = searchRoutes[boundIndex];

  if (tripSegments.length > 0 && searchRoute?.originCode) {
    const firstSegmentOrigin = tripSegments[0].origin;

    return !isMatchingLocation(searchRoute.originCode, firstSegmentOrigin);
  }

  return false;
};

export const isDifferentDestination = (
  searchRoutes: SearchRoutes,
  segments: SegmentsType,
  boundIndex: number,
): boolean => {
  const tripSegments = filterTripSegments(segments);

  if (!searchRoutes) {
    return false;
  }

  const searchRoute = searchRoutes[boundIndex];

  if (tripSegments.length > 0 && searchRoute?.destinationCode) {
    const lastSegmentDestination = tripSegments[tripSegments.length - 1].destination;

    return !isMatchingLocation(searchRoute.destinationCode, lastSegmentDestination);
  }

  return false;
};

export const isTripWithDifferentOriginOrDestination = (
  searchRoutes: SearchRoutes,
  bounds: BoundsType,
) => {
  return bounds.some((bound, boundIndex) => {
    const segments = bound.segments.filter((segment) => Boolean(segment));

    return (
      isDifferentOrigin(searchRoutes, segments, boundIndex) ||
      isDifferentDestination(searchRoutes, segments, boundIndex)
    );
  });
};
